export const Type_ClipboardTerm = 'clipboard-term';
export const Type_ClipboardAtom = 'clipboard-atom';
//# sourceMappingURL=types.js.map